import _round from 'lodash/round';

interface CalculatePlanPriceInput {
    detectionsAvailable: number;
    enableGapAnalysis: boolean;
    planSettings: ChargebeePlanSettings | null;
}

export const calculatePlanPrice = ({
    detectionsAvailable,
    enableGapAnalysis,
    planSettings,
}: CalculatePlanPriceInput): number => {
    const additionalDetections =
        detectionsAvailable - (planSettings?.DETECTION_TRACKS_INCLUDED ?? 0);
    const pricePerAdditionalDetection =
        planSettings?.DETECTION_COST_PER_TRACK ?? 0;
    const costOfDetections =
        additionalDetections < 1 && pricePerAdditionalDetection > 0
            ? 0
            : additionalDetections * pricePerAdditionalDetection;

    // TODO https://app.asana.com/0/1150917131612043/1201375140931903
    // get GA pricing from planSettings
    const costOfGapAnalysis =
        planSettings?.id === 'CHARGEBEE_PLAN_SCALE' && enableGapAnalysis
            ? 85
            : 0;

    const priceCalculated =
        (planSettings?.BASE_COST ?? 0) + costOfDetections + costOfGapAnalysis;

    return _round(priceCalculated, 2);
};
